import { render, staticRenderFns } from "./CreditIndex.vue?vue&type=template&id=65e4de48"
import script from "./CreditIndex.vue?vue&type=script&lang=js"
export * from "./CreditIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports